import { Location } from 'history';
import { QUERY_STRING } from '../enums/QueryString';
import { Query } from '../definitions/query';

export interface UTMParams {
  utmCampaign: string;
  utmContent: string;
  utmMedium: string;
  utmSource: string;
  utmTerm: string;
}

export function composeQueryString(query: Query, initialQuery = '') {
  let q = initialQuery;

  Object.keys(query)
    // filter nullish values to avoid putting empty query strings (e.g. ?key=&foo=bar)
    .filter((k) => {
      const val = query[k];

      try {
        // if it's an array, it must have something in them; because !![]
        // would return true and an empty query string would be added unnecessarily
        return Object.hasOwnProperty.call(val, 'length')
          ? val.length > 0
          : !!val;
      } catch (e) {
        return !!val;
      }
    })
    .forEach((k: string) => {
      // URI values are escaped. Read them using URLSearchParams
      q += `${q === '' ? '?' : '&'}${k}=${encodeURIComponent(query[k])}`;
    });

  return q;
}

/**
 * If an email query string param follows the format: [part1]+[part2]@[domain].com;
 * and it wasn't properly encoded for being URL-safe (e.g. copy-pasting a URL
 * and manually typing the email), then the '+' character is treated as an
 * empty space by URLSearchParams, so the resulting string is 'part1 part2@domain.com'.
 * So, we basically replace the '+' by the URL-safe character, which is its
 * Hex representation prepended by a '%', so '+' is replaced by %2B.
 */
export const getEmailQueryString = (location: Location): string => {
  const encodedQuery = location.search.replace(/\+/g, encodeURIComponent('+'));
  return new URLSearchParams(encodedQuery).get(QUERY_STRING.EMAIL) || '';
};
